import { conciliatorGateway } from "../domain/conciliator.gateway";

export class ProcessUseCase {
  constructor(private gateway: conciliatorGateway) {}

  async execute(ids: number[]): Promise<void> {
    return await this.gateway.process(ids);
  }
}